import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';

export const Timeline = styled.div`
  ${mixins.flexPosition({ justify: 'flex-start' })}
  ${mixins.customScrollbar()}
  overflow-x: auto;
  padding-bottom: 10px;

  &::-webkit-scrollbar {
    height: 6px;
  }
`;

export const Circle = styled.div`
  background-color: ${({ color }) => color || styles.colors.GRAY_LIGHT_2};
  border: 1px solid ${({ borderColor }) => borderColor};
  border-radius: 10px;
  height: 20px;
  margin-bottom: 5px;
  position: relative;
  width: 20px;

  &::after,
  &::before {
    background-color: ${styles.colors.GRAY_LIGHT_2};
    content: '';
    height: 1px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 90px;
  }

  &::after {
    left: 20px;
  }

  &::before {
    right: 20px;
  }
`;

export const Title = styled.div`
  ${mixins.fontStyle(
    styles.colors.GRAY_DARKER,
    styles.fontSizes.SIZE_7,
    styles.fontWeights.SEMIBOLD
  )}
  line-height: 17px;
`;

export const Item = styled.div`
  ${mixins.flexPosition({ align: 'center', direction: 'column' })}
  flex-shrink: 0;
  overflow: hidden;
  padding: 0 20px;

  &:first-child {
    padding-left: 0;

    ${Circle}::before {
      content: none;
    }
  }

  &:last-child {
    padding-right: 0;

    ${Circle}::after {
      content: none;
    }
  }
`;

export const Date = styled.div`
  ${mixins.fontStyle(
    styles.colors.GRAY_MEDIUM_3,
    styles.fontSizes.SIZE_7,
    styles.fontWeights.NORMAL
  )}
  line-height: 17px;
`;



// WEBPACK FOOTER //
// ./src/screens/Home/Components/OrderDetails/Components/BoxStatus/style.js